import { PersonServiceConfiguration } from '@smartobjx/smart.connectors';
import { AuthService } from './authentication/auth.service';
import { environment } from '../../environments/environment';

export function personConfigurationService() {
  return (_authenticationService: AuthService): PersonServiceConfiguration => {
    return new PersonServiceConfiguration({
      httpClient: _authenticationService.httpClient,
      basePath: environment.settingsServiceBasePath,
      SubscriberToken: _authenticationService.getTokenId(),
      POVToken: _authenticationService.getPOV()
    });
  };
}